import React from 'react';
import { Input, Button } from 'reactstrap';
import classnames from 'classnames';
import GradeEventCard from '../../Grade/components/GradeEventCard';
import { formatDate } from '../../../utils/date';

export const EvaluationSidebar = ({
    activeTab,
    setActiveTab,
    selectedEmployeeId,
    setSelectedEmployeeId,
    employees,
    currentDate,
    handlePrevDay,
    handleNextDay,
    todaySchedules,
    selectedSchedule,
    setSelectedSchedule
}) => {
    return (
        <div className={`h-100 d-flex flex-column bg-white shadow-sm rounded border ${selectedSchedule ? "d-none d-md-flex" : "d-flex"}`} style={{ overflow: 'hidden' }}>
            {/* STICKY HEADER AREA */}
            <div className="bg-white border-bottom z-1" style={{ position: 'sticky', top: 0 }}>
                {/* 1. DATE NAVIGATION (MINIMALIST) */}
                <div className="d-flex align-items-center justify-content-between p-3 pb-2">
                    <Button
                        color="light"
                        className="btn-sm rounded-circle d-flex align-items-center justify-content-center border-0 shadow-none text-muted"
                        style={{ width: 32, height: 32 }}
                        onClick={handlePrevDay}
                        disabled={!handlePrevDay}
                    >
                        <i className="mdi mdi-chevron-left fs-4" />
                    </Button>

                    <div className="text-center flex-grow-1">
                        <span className="fw-bold text-dark fs-5">{formatDate(currentDate)}</span>
                    </div>

                    <Button
                        color="light"
                        className="btn-sm rounded-circle d-flex align-items-center justify-content-center border-0 shadow-none text-muted"
                        style={{ width: 32, height: 32 }}
                        onClick={handleNextDay}
                        disabled={!handleNextDay}
                    >
                        <i className="mdi mdi-chevron-right fs-4" />
                    </Button>
                </div>

                {/* 2. MODERN SEGMENTED TABS */}
                <div className="px-3 pb-3">
                    <div className="bg-light rounded p-1 d-flex w-100">
                        <Button
                            color="link"
                            className={classnames("flex-grow-1 text-decoration-none py-1 px-0 m-0 fw-medium border-0 rounded transition-all", {
                                "bg-white text-primary shadow-sm": activeTab === "technical",
                                "text-muted": activeTab !== "technical"
                            })}
                            onClick={() => setActiveTab("technical")}
                            style={{ fontSize: '13px' }}
                        >
                            <i className="mdi mdi-medal-outline me-1"></i>Avaliação
                        </Button>
                        <Button
                            color="link"
                            className={classnames("flex-grow-1 text-decoration-none py-1 px-0 m-0 fw-medium border-0 rounded transition-all", {
                                "bg-white text-primary shadow-sm": activeTab === "performance",
                                "text-muted": activeTab !== "performance"
                            })}
                            onClick={() => setActiveTab("performance")}
                            style={{ fontSize: '13px' }}
                        >
                            <i className="mdi mdi-timer-outline me-1"></i>Testes
                        </Button>
                        <Button
                            color="link"
                            className={classnames("flex-grow-1 text-decoration-none py-1 px-0 m-0 fw-medium border-0 rounded transition-all", {
                                "bg-white text-warning shadow-sm": activeTab === "extras",
                                "text-muted": activeTab !== "extras"
                            })}
                            onClick={() => setActiveTab("extras")}
                            style={{ fontSize: '13px' }}
                        >
                            <i className="mdi mdi-star-outline me-1"></i>Extras
                        </Button>
                    </div>
                </div>

                {/* 3. INSTRUCTOR FILTER (SEAMLESS) */}
                <div className="px-3 pb-3">
                    <div className="position-relative">
                        <i className="mdi mdi-account-search-outline position-absolute text-muted fs-5" style={{ left: '10px', top: '50%', transform: 'translateY(-50%)' }}></i>
                        <Input
                            type="select"
                            value={selectedEmployeeId}
                            onChange={(e) => setSelectedEmployeeId(e.target.value)}
                            className="form-select border-0 bg-light shadow-none ps-5 rounded cursor-pointer"
                            style={{ fontWeight: "500", fontSize: '14px', height: '38px' }}
                        >
                            <option value="">Todos os Professores</option>
                            {employees.map(emp => (
                                <option key={emp.id} value={emp.id}>
                                    {emp.name || `${emp.firstName || ""} ${emp.lastName || ""}`.trim()}
                                </option>
                            ))}
                        </Input>
                    </div>
                </div>
            </div>

            {/* SCROLLABLE LIST OF CLASSES */}
            <div className="flex-grow-1 overflow-auto bg-light p-3" style={{ minHeight: '300px' }}>
                {todaySchedules && todaySchedules.length > 0 ? (
                    <div className="d-flex flex-column gap-2">
                        {todaySchedules.map(schedule => (
                            <GradeEventCard
                                key={schedule.id}
                                schedule={schedule}
                                onClick={() => setSelectedSchedule(schedule)}
                                isSelected={selectedSchedule?.id === schedule.id}
                            />
                        ))}
                    </div>
                ) : (
                    <div className="d-flex flex-column align-items-center justify-content-center text-center h-100 py-5 text-muted">
                        <div className="bg-white rounded-circle d-flex align-items-center justify-content-center shadow-sm mb-3" style={{ width: 64, height: 64 }}>
                            <i className="mdi mdi-clipboard-text-off-outline fs-3 text-secondary" />
                        </div>
                        <h6 className="fw-bold text-dark mb-1">Nenhuma Aula</h6>
                        <p className="font-size-13 mb-0" style={{ maxWidth: '200px' }}>
                            {selectedEmployeeId ? "O professor selecionado não tem turmas hoje." : "Não há turmas agendadas para esta data."}
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};
